export const checksums = {
  "en": "v3.5.0--9ipFbPvsacUXtOHOzMRBx0usnWlVkczj8RpSUtPm84s",
  "fr": "v3.5.0--oF_5dhM3qQ0A2yjxH24uKJehPbGAlKdYBY9TTBt1uBs"
}
export const checksumsStructure = {
  "en": "vSGrWz6AOr48cbPWHe0WFbf7NQ78Iu8tCJiNN9e-qe0",
  "fr": "TH0TckpmgHCO2ZF20dX4kYcKrxyfn4jJqMZQbeg-RnQ"
}

export const tables = {
  "en": "_content_en",
  "fr": "_content_fr",
  "info": "_content_info"
}

export default {
  "en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "dates": "json",
      "description": "string",
      "extension": "string",
      "images": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "number": "number",
      "path": "string",
      "seo": "json",
      "status": "string",
      "stem": "string",
      "subtitle": "string",
      "tags": "json",
      "team": "json",
      "technologies": "json",
      "thumbnail": "string"
    }
  },
  "fr": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "dates": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "number": "number",
      "path": "string",
      "seo": "json",
      "status": "string",
      "stem": "string",
      "subtitle": "string",
      "tags": "json",
      "team": "json",
      "technologies": "json",
      "thumbnail": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}